import React from 'react';

import { Box, Grid } from '@mui/material';
import { TextFieldBase } from '../../inputs/TextFieldBase';
import { PhoneField as PhoneFieldBase } from '../../inputs/PhoneField';
import { withFormController } from '../../hocs/forms';
import { InputLabelBase } from '../../inputs/InputLabelBase';

const TextField = withFormController(TextFieldBase);
const PhoneField = withFormController(PhoneFieldBase);

const inputProps = {
  style: {
    border: 'none',
  },
};

export const AccountOrgContactDefaultFields = ({ disabled }: any) => {
  return (
    <Grid
        container
        style={{ paddingLeft: '25px', paddingRight: '25px' }}
        spacing={8}
      >
        <Grid item md={6}>
          <Box>
            <InputLabelBase required>Current Contact Person</InputLabelBase>
            <Box>
              <Box display="flex">
                <Box paddingRight="1rem" width="50%">
                  <TextField
                    name="contactFirstName"
                    inputProps={inputProps}
                    fullWidth
                    placeholder="Policyholder First Name"
                    disabled={disabled}
                  />
                </Box>
                <Box width="50%">
                  <TextField
                    name="contactLastName"
                    inputProps={inputProps}
                    fullWidth
                    placeholder="Policyholder Last Name"
                    disabled={disabled}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
          <Box>
            <InputLabelBase required>Current Contact Email</InputLabelBase>
            <TextField
              name="contactEmail"
              inputProps={inputProps}
              fullWidth
              placeholder="Policyholder Email"
              disabled={disabled}
            />
          </Box>
        </Grid>
        <Grid item md={6}>
          {/* @ts-expect-error TS(2769): No overload matches this call. */}
          <Box margintop="1rem">
            <InputLabelBase required>Current Mobile Number</InputLabelBase>
            <PhoneField
              name="contactPhone"
              placeholder="(123) 456-7890"
              disabled={disabled}
              fullWidth
              inputProps={inputProps}
            />
          </Box>
        </Grid>
      </Grid>
  );
};
